<template>
  <v-card
      class="mx-auto my-12"
      max-width="668"
      height="680"
  >
    <v-hover>
      <template v-slot:default="{ hover }">
          <v-img height="375" :src="video.image">

          <v-fade-transition>
            <v-img height="375"  v-if="hover" :src="video.preview" >
              <v-overlay
                absolute
                color="#111111"
                opacity="0.7"
                class="video-overlay"
            >
                <v-container class="fill-height">
                  <v-row no-gutters align="end" justify="center" class="fill-height">
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn v-on="on" fab small class="mx-1" :href="`https://www.youtube.com/watch?v=${video.youtubeId}`" target="_blank">
                          <v-icon color="red">mdi-youtube</v-icon>
                        </v-btn>
                      </template>
                      <span>View video on youtube</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn v-on="on" fab small class="mx-1">
                          <v-icon color="primary">mdi-link</v-icon>
                        </v-btn>
                      </template>
                      <span>Copy video link</span>
                    </v-tooltip>

                    <!--
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn v-on="on" fab small class="mx-1" :to="`/play?video=${video.id}`">
                          <v-icon color="primary">mdi-play</v-icon>
                        </v-btn>
                      </template>
                      <span>Play video</span>
                    </v-tooltip>
                    -->

                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-btn v-on="on" fab small class="mx-1" :to="`/videos/${video.id}`">
                          <v-icon color="primary">mdi-comment-text</v-icon>
                        </v-btn>
                      </template>
                      <span>Go to the web page of the video</span>
                    </v-tooltip>
                  </v-row>
                </v-container>
            </v-overlay>
            </v-img>
          </v-fade-transition>
          </v-img>
      </template>
    </v-hover>

    <v-card-text class="fix-height">
      <v-container class="mb-0 fill-height">
        <v-row>
          <h2 class="title primary--text mb-2">
            {{ video.title }}
          </h2>
          {{video.description}}
        </v-row>
        <v-row class="mt-6" align="end" justify="end">
          <v-btn class="primary--text flex-fill" :to="`/videos/${video.id}`">
            Continue reading the full tutorial...
          </v-btn>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-title>
      <v-row no-gutters align="center">
        <v-rating
          :value="video.rate"
          dense
          color="orange"
          background-color="orange"
          hover
          class="mr-2"
      ></v-rating>
      <span class="primary--text mt-2 subtitle-2">{{video.rateCount}} rates</span>
        <v-spacer />
        <v-icon color="primary" class="mr-1">mdi-eye</v-icon>
        <span class="primary--text subtitle-2">{{video.views}} views</span>
      </v-row>
    </v-card-title>
  </v-card>
</template>

<script>
export default {
  name: "VideoIntro",
  props: ['video']
}
</script>

<style>
  .video-overlay > .v-overlay__content {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .fix-height {
    height: 220px !important;
  }
</style>